import { mapState, mapActions, mapMutations } from "vuex"
import Util from '../../util/funcoes'

export default {
  data() {
    return {
      isLoading: false
    }
  },

  created() {
    this.listar();
  },

  computed: {
    ...mapState('contasPagarDoDiaStore', {
      contasPagarDoDia(state) { return state.listaDeContasPagarDoDia }
    }),

    tooltipQuantidadeContasIsVisible() {
      return this.contasPagarDoDia.length > 0;
    },

    quantidadeContas() {
      const quantidade = this.contasPagarDoDia.length;

      switch (quantidade) {
        case 1:
          return 'Exibindo 1 lançamento.'
        default:
          return `Exibindo ${quantidade} lançamentos.`
      }
    }
  },

  methods: {
    ...mapActions('contasPagarDoDiaStore', [
      'recuperarContasPagarDoDia'
    ]),

    ...mapMutations('contasPagarDoDiaStore', [
      'limparContasPagar'
    ]),

    listar() {
      this.showLoading();
      this.limparContasPagar();
      this.recuperarContasPagarDoDia()
      .then()
      .finally(() => {
        this.hideLoading();
      });
    },

    showLoading() {
      this.isLoading = true;
    },
    hideLoading() {
      this.isLoading = false;
    },

    formatarLabelValor(item) {
      return Util.formatarValor(item.valor);
    },
  }
}